import { useMutation } from '@tanstack/react-query';
import { validationsApi, type ValidateModulesRequest, type ValidateModulesResponse } from '@/lib/api';

interface UseValidateModulesOptions {
  onSuccess?: (response: ValidateModulesResponse) => void;
  onError?: (error: Error) => void;
}

export function useValidateModules(options?: UseValidateModulesOptions) {
  return useMutation({
    mutationFn: (data: ValidateModulesRequest) =>
      validationsApi.validateModules(data),
    onSuccess: (response) => {
      options?.onSuccess?.(response);
    },
    onError: (error) => {
      console.error('Module validation failed:', error);
      options?.onError?.(error instanceof Error ? error : new Error(String(error)));
    },
  });
}
